var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c("EventHeader"),
      _c(
        "div",
        { staticClass: "body" },
        [
          _vm.isLoading
            ? _c("vue-loading", {
                attrs: {
                  type: "spiningDubbles",
                  color: "#efad4c",
                  size: { width: "50px", height: "50px" },
                },
              })
            : [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("eventTheme.title"))),
                ]),
                _c("div", {
                  staticClass: "description",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("eventTheme.description")),
                  },
                }),
                _vm.items.length
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.items, function (item) {
                          return [
                            _c("EventThemeItem", {
                              key: item.id,
                              attrs: { item: item },
                            }),
                          ]
                        }),
                      ],
                      2
                    )
                  : _c("div", { staticClass: "empty-card" }, [
                      _vm._v(_vm._s(_vm.$t("eventTheme.noThemes"))),
                    ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }